/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { identityResolve } from "../funcs/identityResolve.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import { IdentityModel } from "../models/components/identitymodel.js";
import {
  ResolveIdentityRequest,
  ResolveIdentitySecurity,
} from "../models/operations/resolveidentity.js";
import { unwrapAsync } from "../types/fp.js";

export class Identity extends ClientSDK {
  /**
   * resolve identity
   *
   * @remarks
   * Resolve an identity URN into every identifier the subject's activity is recorded under.
   */
  async resolve(
    request: ResolveIdentityRequest,
    security?: ResolveIdentitySecurity | undefined,
    options?: RequestOptions,
  ): Promise<IdentityModel> {
    return unwrapAsync(identityResolve(
      this,
      request,
      security,
      options,
    ));
  }
}
